export const SET_MODAL_BOOK = 'SET_MODAL_BOOK' as const;
export const SET_MODAL_EDIT_BOOK = 'SET_MODAL_EDIT_BOOK' as const;

export const GET_ORDERS_BOOK_REQUEST = 'GET_ORDERS_BOOK_REQUEST' as const;
export const GET_ORDERS_BOOK_SUCCESS = 'GET_ORDERS_BOOK_SUCCESS' as const;
export const GET_ORDERS_BOOK_ERROR = 'GET_ORDERS_BOOK_ERROR' as const;

export const DELETE_ORDERS_MODAL = 'DELETE_ORDERS_MODAL' as const;

export const GET_ORDERS_OZM_REQUEST = 'GET_ORDERS_OZM_REQUEST' as const;
export const GET_ORDERS_OZM_SUCCESS = 'GET_ORDERS_OZM_SUCCESS' as const;
export const GET_ORDERS_OZM_ERROR = 'GET_ORDERS_OZM_ERROR' as const;

export const CREATE_CELL_REQUEST = 'CREATE_CELL_REQUEST' as const;
export const CREATE_CELL_SUCCESS = 'CREATE_CELL_SUCCESS' as const;

export const CLEAN_ERROR_BOOK = 'CLEAN_ERROR_BOOK' as const;
export const CLEAN_BOOK_STATE = 'CLEAN_BOOK_STATE' as const;

export const CLEAN_IDDP = 'CLEAN_IDDP' as const;
